import { z } from 'zod';
import { dateRangeSchema } from 'utils/schemas';

export const adminReportsFiltersSchema = z.object({
  date: dateRangeSchema,
});
